import {
  AppBar,
  Hidden,
  IconButton,
  Toolbar,
  Typography,
  useTheme,
} from "@mui/material";
import React, { useState } from "react";
import Box from "@mui/material/Box";
import MenuIcon from "@mui/icons-material/Menu";

function Navbar({ handleDrawerToggle }) {
  const theme = useTheme();
  return (
    <Box sx={{ flexGrow: 1, zIndex: 1251 }}>
      <AppBar
        position="fixed"
        sx={{ backgroundColor: "#015A96", zIndex: 1251 }}
      >
        <Toolbar
          variant="dense"
          style={{
            display: "flex",
            justifyContent: "flex-end",
            minHeight: "65px",
          }}
        >
          <Typography
            className=" d-flex justify-content-center"
            variant="h6"
            component="div"
            sx={{ flexGrow: 1 }}
          >
            Dashboard
          </Typography>
          <Box>
            <Hidden mdUp>
              <IconButton onClick={handleDrawerToggle}>
                <MenuIcon style={{ color: "white" }} />
              </IconButton>
            </Hidden>
          </Box>
        </Toolbar>
      </AppBar>
    </Box>
  );
}

export default Navbar;
